exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-719dd8a9]{text-decoration:none!important}a[data-v-719dd8a9]:active{color:red!important;font-weight:700!important}.text-h4-index[data-v-719dd8a9]{line-height:2.5rem;font-size:2.125rem!important;letter-spacing:.00735294em!important}.text-caption-index[data-v-719dd8a9]{font-size:.75rem;letter-spacing:.03em}.landing-top-image[data-v-719dd8a9]{background-image:url(/img/IndexHeader.png);background-size:cover;background-position:top;height:350px}.description[data-v-719dd8a9]{max-height:100px;overflow:hidden;text-overflow:ellipsis}.index-scroll-bar[data-v-719dd8a9]{overflow-y:hidden}", ""]);

// exports
